export const CIF = {
  // Nav
  nav: "cif-nav",
  navLogo: "cif-nav-logo",
  navLinkProblem: "cif-nav-link-problem",
  navLinkHow: "cif-nav-link-how",
  navLinkBreakdown: "cif-nav-link-breakdown",
  navLinkWhy: "cif-nav-link-why",
  navLinkWorkspace: "cif-nav-link-workspace",
  navLinkFaq: "cif-nav-link-faq",
  navCtaWorkspace: "cif-nav-cta-create-workspace",

  // Hero
  hero: "cif-hero",
  heroEyebrow: "cif-hero-eyebrow",
  heroHeadline: "cif-hero-headline",
  heroSubheadline: "cif-hero-subheadline",
  heroDescription: "cif-hero-description",
  heroCtaPrimary: "cif-hero-cta-estimate",
  heroCtaSecondary: "cif-hero-cta-workspace",
  heroTrustBar: "cif-hero-trust-bar",

  // Calculator (Hero visual)
  calc: "cif-calculator",
  calcInputFactoryPrice: "cif-input-factory-price",
  calcInputCountry: "cif-input-country",
  calcInputPort: "cif-input-port",
  calcInputContainer: "cif-input-container",
  calcInputQuantity: "cif-input-quantity",
  calcInputFreight: "cif-input-freight",
  calcInputInsurance: "cif-input-insurance",
  calcOutCif: "cif-output-cif",
  calcOutLanded: "cif-output-landed",
  calcOutPerMt: "cif-output-per-mt",
  calcOutLastUpdated: "cif-output-last-updated",

  // Problem
  problem: "cif-problem-section",

  // How it works
  how: "cif-how-section",
  howStep: (i) => `cif-how-step-${i}`,

  // Cost breakdown
  breakdown: "cif-breakdown-section",
  breakdownCard: (key) => `cif-breakdown-card-${key}`,

  // Why
  why: "cif-why-section",
  whyCard: (i) => `cif-why-card-${i}`,

  // Workspace integration
  workspace: "cif-workspace-section",
  workspaceNode: (key) => `cif-workspace-node-${key}`,

  // FAQ
  faq: "cif-faq-section",
  faqItem: (i) => `cif-faq-item-${i}`,
  faqTrigger: (i) => `cif-faq-trigger-${i}`,

  // Final CTA
  finalCta: "cif-final-cta-section",
  finalCtaPrimary: "cif-final-cta-estimate",
  finalCtaSecondary: "cif-final-cta-workspace",

  // Lead dialog
  leadDialog: "cif-lead-dialog",
  leadInputName: "cif-lead-name",
  leadInputEmail: "cif-lead-email",
  leadInputCompany: "cif-lead-company",
  leadSubmit: "cif-lead-submit",
};

export default CIF;
